import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Spacer } from '@zillow/constellation';

import LoadingConstants from 'app/shared/constants/LoadingConstants';
import propertyUtils from 'app/shared/utils/propertyUtils';
import SpinnerContainer from 'app/shared/components/SpinnerContainer';

import { StyledContainer, StyledText } from './StyledComponents';

const noop = () => { };

const propTypes = {
    properties: PropTypes.array,
    onLoadProperties: PropTypes.func,
    isLoading: PropTypes.bool,
};

const defaultProps = {
    properties: [],
    onLoadProperties: noop,
    isLoading: false,
};

const UserManagementPropertyListModal = ({
    properties,
    onLoadProperties,
    isLoading,
}) => {
    const formattedProperties = properties.map(property => propertyUtils.formatAddress(property));

    React.useEffect(() => {
        onLoadProperties();
    }, []);

    return (
        <StyledContainer>
            {isLoading
                ? <SpinnerContainer />
                : formattedProperties.map((property, i) => (
                    <Spacer margin="sm">
                        <StyledText as="div" key={i} odd={i % 2 === 0 ? 'odd' : ''}>
                            {property.formattedName && `${property.formattedName} `}
                            {property.formattedAddress}
                        </StyledText>
                    </Spacer>
                ))
            }
        </StyledContainer>
    );
};

UserManagementPropertyListModal.propTypes = propTypes;
UserManagementPropertyListModal.defaultProps = defaultProps;

const mapStateToProps = state => ({
    properties: state.userManagement.currentUser.properties,
    isLoading: state.userManagement.currentUser.propertiesLoadingState === LoadingConstants.LOADING,
});

export default connect(mapStateToProps)(UserManagementPropertyListModal);
